import { useContext } from 'react';
import MembersContext from 'router/subrouters/DataRoom/providers/Members/Members.context';

export default function useMembers() {
  const { sellSideMembers, buySideMembers, buySideGroups } =
    useContext(MembersContext);

  return {
    sellSideMembers,
    buySideMembers,
    buySideGroups,
  };
}
